var _defs, _rect, _rect2, _path, _circle, _circle2, _g, _rect3, _polygon, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutAbstract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f1f38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2c1c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2a8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blob",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4bd5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4bd5ff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bar",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4bd5ff",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.4,
    fill: "#ffffff",
    fillOpacity: 0.18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 20,
    width: 160,
    height: 160,
    fill: "url(#dots)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 70 C 200 30, 300 90, 290 180 S 220 330, 140 310 S 20 230, 50 150 S 80 90, 120 70 Z",
    fill: "url(#blob)",
    opacity: 0.85
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 290,
    r: 70,
    fill: "none",
    stroke: "#4bd5ff",
    strokeWidth: 14,
    strokeOpacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 290,
    r: 40,
    fill: "#1f1f38",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30 200 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 190,
    width: 200,
    height: 10,
    rx: 5,
    fill: "url(#bar)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 214,
    width: 150,
    height: 10,
    rx: 5,
    fill: "url(#bar)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 238,
    width: 100,
    height: 10,
    rx: 5,
    fill: "url(#bar)",
    opacity: 0.45
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 60,
    width: 44,
    height: 44,
    rx: 8,
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    transform: "rotate(25 322 82)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "70,330 110,330 90,295",
    fill: "#4bd5ff",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 10,
    fill: "#ffffff",
    fillOpacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 200,
    r: 5,
    fill: "#4bd5ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAbstract);
export default __webpack_public_path__ + "static/media/about-abstract.9db1008c25af7785d13b06b13dee1a8d.svg";
export { ForwardRef as ReactComponent };